import { t, font } from "@realtyflows/ui";

export default function MiniBarChart({ data }) {
  const max = Math.max(...data.map(d => d.clients));
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 64, padding: "0 4px" }}>
      {data.map((d, i) => (
        <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
          <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 2, height: 52, justifyContent: "flex-end" }}>
            <div style={{ height: `${(d.deals / max) * 100}%`, background: t.emeraldDeep, borderRadius: "3px 3px 0 0", minHeight: 4, transition: "height 0.5s ease" }} />
            <div style={{ height: `${(d.showings / max) * 100}%`, background: t.emerald, borderRadius: "3px 3px 0 0", minHeight: 4 }} />
            <div style={{ height: `${(d.clients / max) * 100}%`, background: `${t.emerald}20`, borderRadius: "3px 3px 0 0", minHeight: 4 }} />
          </div>
          <span style={{ fontSize: 9, color: t.textMuted, fontFamily: font.mono }}>{d.week}</span>
        </div>
      ))}
    </div>
  );
}
